/**
 * Category Icon Resolver - Pro-Max V2
 * Maps category labels to SVG icons via sprite sheet.
 * Uses tiered matching: explicit map -> keyword match -> fallback.
 */

const FALLBACK_ICON = 'layers';

/** Icon registry: iconKey -> SVG path/innerHTML (Lucide style, viewBox 0 0 24 24) */
const ICON_REGISTRY = {
  laptop: '<path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"/>',
  layers: '<path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/>',
  sparkles: '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>',
  'thumbs-up': '<path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/>',
  camera: '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/>',
  headphones: '<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>',
  monitor: '<rect width="20" height="14" x="2" y="3" rx="2"/><line x1="8" x2="16" y1="21" y2="21"/><line x1="12" x2="12" y1="17" y2="21"/>',
  smartphone: '<rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/>',
  gamepad2: '<path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"/>',
  watch: '<path d="m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05"/><path d="m7.88 16.34.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05"/>',
  utensils: '<path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>',
  cooler: '<path d="M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z"/><path d="M5 10h14"/><path d="M15 7v6"/>',
  home: '<path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>',
  wrench: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
  bike: '<circle cx="18.5" cy="17.5" r="3.5"/><circle cx="5.5" cy="17.5" r="3.5"/><circle cx="15" cy="5" r="1"/><path d="M12 17.5V14l-3-3 4-3 2 3h2"/>',
  dumbbell: '<path d="M14.4 14.4 9.6 9.6"/><path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"/><path d="m2.5 2.5 1.4 1.4"/><path d="M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"/>',
  tent: '<path d="M3.5 21 14 3"/><path d="M20.5 21 10 3"/><path d="M15.5 21 12 15l-3.5 6"/><path d="M2 21h20"/>',
  shirt: '<path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>',
  luggage: '<path d="M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2"/><path d="M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14"/><path d="M10 20h4"/>',
  music: '<path d="M9 18V5l12-2v13"/>',
  keyboard: '<path d="M10 8h.01"/><path d="M12 12h.01"/><path d="M14 8h.01"/><path d="M16 12h.01"/><path d="M18 8h.01"/><path d="M6 8h.01"/><path d="M7 16h10"/>',
  mouse: '<rect x="5" y="2" width="14" height="20" rx="7"/><path d="M12 6v4"/>',
  cupSoda: '<path d="m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8"/><path d="M5 8h14"/><path d="M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0"/>',
  folder: '<path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/>',
};

/** iconKey -> color family */
const ICON_FAMILY_MAP = {
  laptop: 'tech', monitor: 'tech', smartphone: 'tech', camera: 'tech',
  headphones: 'tech', gamepad2: 'tech', keyboard: 'tech', mouse: 'tech', music: 'tech',
  home: 'home', utensils: 'home', cooler: 'home', wrench: 'home', cupSoda: 'home', folder: 'home', layers: 'home',
  bike: 'sports', dumbbell: 'sports', tent: 'sports',
  shirt: 'apparel', watch: 'apparel', luggage: 'apparel',
  sparkles: 'neutral', 'thumbs-up': 'neutral',
};

/** Explicit map: ebay_category_id or normalized full_label -> iconKey */
const EXPLICIT_MAP = {};

/** Keyword map: lowercase keyword -> iconKey */
const KEYWORD_MAP = {
  laptop: 'laptop', notebook: 'laptop', notebooks: 'laptop', computer: 'laptop', computers: 'laptop',
  macbook: 'laptop', chromebook: 'laptop', netbook: 'laptop', netbooks: 'laptop',
  cooking: 'utensils', kitchen: 'utensils', cookware: 'utensils',
  cooler: 'cooler', coolers: 'cooler', icebox: 'cooler', iceboxes: 'cooler', 'ice': 'cooler',
  canteen: 'cupSoda', canteens: 'cupSoda',
  headphone: 'headphones', headphones: 'headphones', audio: 'headphones', speaker: 'headphones',
  speakers: 'headphones', earbud: 'headphones', earbuds: 'headphones',
  camera: 'camera', cameras: 'camera', lens: 'camera', lenses: 'camera', photography: 'camera',
  game: 'gamepad2', gaming: 'gamepad2', console: 'gamepad2', consoles: 'gamepad2', video: 'gamepad2',
  watch: 'watch', watches: 'watch', mouse: 'mouse', mice: 'mouse', trackball: 'mouse',
  trackballs: 'mouse', touchpad: 'mouse', touchpads: 'mouse', keyboard: 'keyboard', keyboards: 'keyboard',
  bicycle: 'bike', bike: 'bike', bikes: 'bike', 'e-bike': 'bike', cycling: 'bike',
  bottle: 'cupSoda', bottles: 'cupSoda', hydration: 'cupSoda', flask: 'cupSoda', flasks: 'cupSoda',
  furniture: 'home', outdoor: 'home', garden: 'home', appliance: 'home', appliances: 'home', vacuum: 'home',
  tool: 'wrench', tools: 'wrench', drill: 'wrench', drills: 'wrench', saw: 'wrench', saws: 'wrench', power: 'wrench',
  sports: 'dumbbell', exercise: 'dumbbell', fitness: 'dumbbell', gym: 'dumbbell',
  camping: 'tent', hiking: 'tent', kayak: 'tent', kayaks: 'tent',
  handbag: 'shirt', handbags: 'shirt', sneaker: 'shirt', sneakers: 'shirt', apparel: 'shirt', clothing: 'shirt',
  luggage: 'luggage', suitcase: 'luggage', suitcases: 'luggage', travel: 'luggage',
  music: 'music', guitar: 'music', instrument: 'music', instruments: 'music',
  monitor: 'monitor', monitors: 'monitor', tv: 'monitor', television: 'monitor', display: 'monitor',
  phone: 'smartphone', smartphone: 'smartphone', mobile: 'smartphone', cell: 'smartphone',
};

const CONDITION_ICONS = { 'like new': 'sparkles', 'very good': 'thumbs-up' };

const SPRITE_ID = 'category-icon-sprite';

/**
 * Inject the SVG sprite sheet into the DOM. Idempotent.
 */
export function injectCategoryIconSprite() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(SPRITE_ID)) return;

  const symbols = Object.keys(ICON_REGISTRY).map((key) => {
    const inner = ICON_REGISTRY[key];
    return `<symbol id="icon-${key}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${inner}</symbol>`;
  }).join('');

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('id', SPRITE_ID);
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svg.setAttribute('aria-hidden', 'true');
  svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  svg.innerHTML = `<defs>${symbols}</defs>`;

  const body = document.body || document.documentElement;
  body.insertBefore(svg, body.firstChild);
}

function tokenize(label) {
  if (!label || typeof label !== 'string') return [];
  return label.split(/\s*[>&,]\s*|\s+/).map((t) => t.toLowerCase().trim()).filter(Boolean);
}

function resolveIconKey(category, options = {}) {
  if (typeof category === 'string') category = { label: category, fullLabel: category, shortLabel: category };
  const id = (category.id ?? '').toString().trim();
  const fullLabel = (category.fullLabel ?? category.full_label ?? category.label ?? '').toString().trim();
  const shortLabel = (category.shortLabel ?? category.short_label ?? '').toString().trim();
  const label = (category.label ?? fullLabel ?? shortLabel ?? id ?? '').toString().trim();

  if (id && EXPLICIT_MAP[id]) return EXPLICIT_MAP[id];
  const normFull = fullLabel.toLowerCase().replace(/\s+/g, ' ').trim();
  if (normFull && EXPLICIT_MAP[normFull]) return EXPLICIT_MAP[normFull];

  const fullTokens = options.preferLeaf && shortLabel ? [] : tokenize(fullLabel);
  const shortTokens = tokenize(shortLabel);
  const allTokens = [...new Set([...shortTokens, ...fullTokens])];

  let bestKey = null, bestLen = 0;
  for (const token of allTokens) {
    const key = KEYWORD_MAP[token];
    if (key && token.length > bestLen) { bestKey = key; bestLen = token.length; }
    for (const kw of Object.keys(KEYWORD_MAP)) {
      if (kw.includes(' ') && token.includes(kw) && kw.length > bestLen) { bestKey = KEYWORD_MAP[kw]; bestLen = kw.length; }
    }
  }
  return bestKey || FALLBACK_ICON;
}

function resolveFamily(iconKey) {
  return ICON_FAMILY_MAP[iconKey] ?? 'neutral';
}

/**
 * Build lightweight <svg><use href="#icon-X"/></svg> reference.
 */
function buildUseRef(iconKey, options = {}) {
  const size = options.size ?? 24;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#icon-${iconKey}"/></svg>`;
}

/**
 * Get category icon as { html, family } for sprite-based rendering.
 */
export function getCategoryIcon(category, options = {}) {
  const iconKey = resolveIconKey(category, options);
  const family = resolveFamily(iconKey);
  const html = buildUseRef(iconKey, options);
  return { html, family };
}

/**
 * Backward compatibility: returns SVG HTML string only.
 */
export function getCategoryIconSvg(category, options = {}) {
  return getCategoryIcon(category, options).html;
}

/**
 * Get condition icon (e.g. Like New -> sparkles, Very Good -> thumbs-up).
 */
export function getConditionIcon(condition, options = {}) {
  const norm = (condition ?? '').toString().toLowerCase().trim();
  const iconKey = CONDITION_ICONS[norm] ?? FALLBACK_ICON;
  const family = resolveFamily(iconKey);
  const html = buildUseRef(iconKey, options);
  return { html, family };
}
